<template>
    <div class="warranty-select">
        <div v-if="services.length" class="warranty-select__grid">
            <button
                v-for="service in services"
                :key="service.id"
                type="button"
                class="warranty-select__card"
                :class="{
                    'warranty-select__card--selected': isSelected(service.id),
                    'warranty-select__card--disabled': disabled,
                }"
                :disabled="disabled"
                @click="handleSelect(service)"
            >
                <div class="warranty-select__title">{{ service.name }}</div>
                <div class="warranty-select__subtitle">
                    {{ getCostText(service.percent) }}
                </div>
            </button>
        </div>
    </div>
</template>

<script>
import { LIST_WARRANTY_SERVICE } from "@/core/services/store/contract/contract.module";

export default {
    name: "WarrantySelect",
    props: {
        selectedId: {
            type: Number,
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            services: [],
        };
    },
    watch: {
        selectedId(newValue) {
            if (!this.services.length || newValue === null || newValue === undefined || newValue === "") {
                return;
            }

            this.syncSelectedService(newValue);
        },
    },
    mounted() {
        this.fetchWarrantyServices();
    },
    methods: {
        async fetchWarrantyServices() {
            try {
                const response = await this.$store.dispatch(LIST_WARRANTY_SERVICE);
                const services = Array.isArray(response && response.data) ? response.data : [];

                this.services = services.map((item) => ({
                    id: item.id,
                    name: item.name,
                    percent: Number(item.percent_price != null ? item.percent_price : 0),
                }));

                this.syncSelectedService(this.selectedId);
            } catch (error) {
                this.services = [];
            }
        },
        syncSelectedService(selectedId) {
            if (selectedId !== null && selectedId !== undefined && selectedId !== "") {
                this.emitSelectedService(selectedId);
                return;
            }

            const defaultService = this.services.find((item) => item.percent === 0);

            if (defaultService) {
                this.$emit("selected", defaultService);
            }
        },
        handleSelect(service) {
            if (this.disabled) {
                return;
            }

            this.$emit("selected", service);
        },
        emitSelectedService(id) {
            const selectedService = this.services.find((item) => Number(item.id) === Number(id));

            if (selectedService) {
                this.$emit("selected", selectedService);
            }
        },
        isSelected(id) {
            return Number(this.selectedId) === Number(id);
        },
        getCostText(percent) {
            if (percent === 0) {
                return "0 đ";
            }

            return percent + "% tổng giá khóa";
        },
    },
};
</script>

<style scoped>
.warranty-select__grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 12px;
}

.warranty-select__card {
    width: 100%;
    min-height: 72px;
    padding: 12px 16px;
    border: 1px solid #d9deea;
    border-radius: 14px;
    background: #fbfcff;
    text-align: left;
    cursor: pointer;
    transition: border-color 0.2s ease, background-color 0.2s ease, box-shadow 0.2s ease,
        transform 0.2s ease;
}

.warranty-select__card:not(.warranty-select__card--selected):hover {
  border-color: #b9c8e6;
  background: #f7faff;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
  transform: translateY(-1px);
}

.warranty-select__card--disabled {
  cursor: not-allowed;
}

.warranty-select__card--disabled:not(.warranty-select__card--selected):hover {
  border-color: #d9deea;
  background: #fbfcff;
  box-shadow: none;
  transform: none;
}

.warranty-select__card--selected {
    border-color: #005BBF;
    background: #f2f7ff;
    border-width: 2px;
    box-shadow: 0 2px 8px rgba(0, 91, 191, 0.15);
}

.warranty-select__title {
    font-size: 14px;
    font-weight: 600;
    line-height: 1.45;
    color: #2f3a4c;
}

.warranty-select__subtitle {
    margin-top: 4px;
    font-size: 12px;
    font-weight: 500;
    line-height: 1.45;
    color: #7a8599;
}

@media (max-width: 768px) {
    .warranty-select__grid {
        grid-template-columns: 1fr;
    }
}
</style>
